export const manifestcountId = 'manifestcountId';
export const measurecountId = 'measurecountId';
export const notecountId = 'notecountId';
export const hopeId = 'hopeId';
export const facetofaceId = 'facetofaceId';
export const taskadmincountId = 'taskadmincountId';
export const problemcountId = 'problemcountId';
export const physicianservicesId = 'physicianservicesId';
